export default __webpack_public_path__ + "/_/goose-next.55218b26.png";